import React from 'react'
import styled from 'styled-components'
import BigCheckIcon from '~/src/assets/images/big-check.svg'

// Styled component to replace makeStyles
const CheckMarkContainer = styled.div`
  height: 100px;
  margin: var(--space-14) 0 var(--space-12) 0;
  text-align: center;
  width: 100%;

  & img {
    height: 100%;
  }
`

export default function CheckedBanner() {
  return (
    <CheckMarkContainer data-testid="checked-banner-container">
      <img src={BigCheckIcon} alt="checkmark" data-testid="checked-banner-image" />
    </CheckMarkContainer>
  )
}
